import {
  number,
  object,
  string,
} from 'yup';

import MESSAGE from 'validations/constants/messages';
export const groupsFormSchema = (companyId) => {
  const baseSchema = object().shape({
    details: object()
      .shape({
        address: object().shape({
          postal_code: string()
            .matches(/^[0-9]+$/, MESSAGE.NUMBER)
            .length(5, MESSAGE.LENGTH),
        }),
        contact: object().shape({
          email: string()
            .email(MESSAGE.EMAIL),
        }),
      })
      .default({}),
    id: number()
      .integer()
      .positive(),
    name: string()
      .min(3, MESSAGE.MIN_LENGTH)
      .trim()
      .required(MESSAGE.REQUIRED),
    parent: number()
      .integer(),
  });
  if (companyId === 3638) {
    return baseSchema.shape({
      details: object().shape({
        ruc: string()
          .matches(/^[0-9]{13}$/, 'RUC debe tener exactamente 13 dígitos')
          .required('RUC es requerido'),
        'full-address': string()
          .required('Domicilio completo es requerido'),
        percentage: number()
          .min(0, 'El porcentaje no puede ser menor a 0')
          .max(1.0, 'El porcentaje no puede ser mayor a 1.0')
          .required('Porcentaje es requerido'),
        contact: object().shape({
          email: string()
            .email('Correo electrónico debe ser válido')
            .required('Correo electrónico es requerido'),
          phone_number: string()
            .required('Número telefónico es requerido'),
        }),
      }),
    });
  }


  return baseSchema;
};
